export default __webpack_public_path__ + "87ccaaa4ac162309c71ac0e1b86bc8e4.png";